import type { ApiMessage } from '@xtreed/academy-shared';
import { api } from './api';

export enum ReactionType {
  LIKE = 'LIKE',
  LOVE = 'LOVE',
  HELPFUL = 'HELPFUL',
}

export interface ToggleReactionResponse extends ApiMessage {
  action: 'added' | 'removed';
}

export interface ReactionStats {
  type: ReactionType;
  count: number;
}

export interface ReactionCountResponse {
  count: number;
}

export interface MyReaction {
  id: string;
  lessonId?: string | null;
  commentId?: string | null;
  type: ReactionType;
}

export const reactionsService = {
  async toggleLessonReaction(
    lessonId: string,
    type: ReactionType = ReactionType.LIKE,
  ): Promise<ToggleReactionResponse> {
    const { data } = await api.post(`/reactions/lessons/${lessonId}`, { type });
    return data?.data || data;
  },

  async toggleCommentReaction(
    commentId: string,
    type: ReactionType = ReactionType.LIKE,
  ): Promise<ToggleReactionResponse> {
    const { data } = await api.post(`/reactions/comments/${commentId}`, {
      type,
    });
    return data?.data || data;
  },

  async getLessonStats(lessonId: string): Promise<ReactionStats[]> {
    const { data } = await api.get(`/reactions/lessons/${lessonId}/stats`);
    return data?.data || data;
  },

  async getCommentReactionCount(
    commentId: string,
  ): Promise<ReactionCountResponse> {
    const { data } = await api.get(`/reactions/comments/${commentId}/count`);
    return data?.data || data;
  },

  async getMyReactions(lessonId?: string): Promise<MyReaction[]> {
    const { data } = await api.get('/reactions/me', {
      params: lessonId ? { lessonId } : {},
    });
    return data?.data || data;
  },
};
